import { ContatoService, MensagensApi } from './../../services/class/contato.service';
// default
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { merge, of as observableOf, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { LoadingService } from './../../services/loading.service';
import { HelperService } from './../../services/helper.service';
import { MatDialog } from '@angular/material/dialog';
import { GlobalService } from './../../services/global.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ContatoMensagem } from 'src/app/models/contato-mensagem.model';

@Component({
  selector: 'app-mensagens',
  templateUrl: './mensagens.component.html',
  styleUrls: ['./mensagens.component.scss']
})
export class MensagensComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['select', '1', '2', '3', '4', '5', 'actions'];
  // nome, email, telefone, estilo, mensagem
  data: ContatoMensagem[] = [];
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  search: string;
  filterSubscription: Subscription;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  selection = new SelectionModel<ContatoMensagem>(true, []);

  constructor(
    public global: GlobalService,
    public contatoService: ContatoService,
    public dialog: MatDialog,
    public helper: HelperService,
    public loadingService: LoadingService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    this.buscarMensagens();
  }

  buscarMensagens() {
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.contatoService.get(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction.toLocaleUpperCase());
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.selection.clear();
          this.resultsLength = data.numeroPaginas * this.paginator.pageSize;
          console.log(data);
          return data.ContatosMensagem;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          this.selection.clear();
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  filter(e) {
    if (this.paginator.pageIndex > 1) {
      this.paginator.pageIndex = 0;
    }
    if (e) {
      if (this.filterSubscription && !this.filterSubscription.closed) {
        this.filterSubscription.unsubscribe();
      }
      this.filterSubscription = this.contatoService.get(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active, this.sort.direction.toLocaleUpperCase(), e.toLocaleLowerCase())
        .subscribe((res: MensagensApi) => {
          this.data = this.paginator.pageIndex == 0 ? res.ContatosMensagem : this.data.concat(res.ContatosMensagem);
        });
    } else {
      this.buscarMensagens();
    }
  }

  clearFilter() {
    this.search = '';
    this.buscarMensagens();
  }

  downloadExcel() {
    this.contatoService.excel().subscribe((res: string) => window.open(res));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.data.forEach(row => this.selection.select(row));
  }

  deletarMensagens() {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        title: 'Excluir mensagens',
        description: 'Você realmente quer excluir essas mensagens? Esse processe não pode ser desfeito.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.contatoService.deleteSelected(this.selection.selected).subscribe((res: any) => {
          this.loadingService.present('Excluindo mensagens');
          this.helper.openSnackBar('Mensagens removidos com sucesso.');
          this.loadingService.dismiss();
          this.buscarMensagens();
        }, e => this.loadingService.dismiss());
      }
    })
  }

  deletarMensagem(mensagem: ContatoMensagem) {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        title: 'Excluir mensagem',
        description: 'Você realmente quer excluir essa mensagem? Esse processe não pode ser desfeito.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadingService.present('Excluindo mensagem...');
        this.contatoService.delete(mensagem).subscribe((res: any) => {
          this.helper.openSnackBar('Mensagem removida com sucesso.');
          this.loadingService.dismiss();
          this.buscarMensagens();
        }, e => this.loadingService.dismiss());
      }
    })
  }

  checkboxLabel(row?: ContatoMensagem): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

}
